export default "__VITE_ASSET__c6920c7e__"